import React, {useEffect, useState} from 'react';
import {autorun} from "mobx";
import {PauseIcon} from "../../../../assets/icons/PauseIcon";
import {PlayIcon} from "../../../../assets/icons/PlayIcon";
import {ScissorsIcon} from "../../../../assets/icons/ScissorsIcon";
import {TrashIcon} from "../../../../assets/icons/TrashIcon";
import {ZoomInIcon} from "../../../../assets/icons/ZoomInIcon";
import {ZoomOutIcon} from "../../../../assets/icons/ZoomOutIcon";
import {UndoIcon} from "../../../../assets/icons/UndoIcon";
import {RedoIcon} from "../../../../assets/icons/RedoIcon";
import {RangeIcon} from "../../../../assets/icons/RangeIcon";
import {RendleyService} from "../../../../services/RendleyService";
import {ApplicationStore} from "../../../../store/ApplicationStore";
import {RendleyStore} from "../../../../store/RendleyStore";
import {TimelineStore} from "../../../../store/TimelineStore";
import {secondsToTimecode} from "../../../../utils/secondsToTimecode";
import './Controls.styles.scss';
import Paper from '../../../../components/Paper/Paper';
import Button from "../../../../components/Button/Button";
import Tooltip from "@mui/material/Tooltip";

const Controls = ({timelineHidden, toggleTimelineHide}) => {
    const [isPlaying, setIsPlaying] = useState(RendleyStore.isPlaying);
    const [displayTime, setDisplayTime] = useState(secondsToTimecode(RendleyStore.currentTime, true));
    const [selectedLibrettoClipId, setSelectedLibrettoClipId] = useState(ApplicationStore.selectedLibrettoClipId);
    const [selectedTransitionId, setSelectedTransitionId] = useState(ApplicationStore.selectedTransitionId);
    const [canUndo, setCanUndo] = useState(RendleyStore.canUndo);
    const [canRedo, setCanRedo] = useState(RendleyStore.canRedo);
    const [rangeEnabled, setRangeEnabled] = useState<boolean>(ApplicationStore.rangeToolEnabled);

    useEffect(() => {
        const dispose = autorun(() => {
            setIsPlaying(RendleyStore.isPlaying);
            setSelectedLibrettoClipId(ApplicationStore.selectedLibrettoClipId);
            setSelectedTransitionId(ApplicationStore.selectedTransitionId);
            setDisplayTime(secondsToTimecode(RendleyStore.currentTime, true));
            setCanUndo(RendleyStore.canUndo);
            setCanRedo(RendleyStore.canRedo);
            setRangeEnabled(ApplicationStore.rangeToolEnabled);
        });

        return () => dispose();
    }, []);

    const handlePlay = () => RendleyService.play();
    const handlePause = () => RendleyService.pause();
    const handleTrash = () => RendleyService.deleteLibrettoClipAtCurrentTime();
    const handleSplit = () => RendleyService.splitLibrettoClipAtCurrentTime();
    const decrementZoom = () => TimelineStore.setZoom(TimelineStore.zoom - 0.1);
    const incrementZoom = () => TimelineStore.setZoom(TimelineStore.zoom + 0.1);
    const handleStop = () => {
        if (isPlaying) {
            RendleyService.getEngine().pause();
        }
        RendleyService.getEngine().seek(0);
    };
    const handleUndo = async () => {
        await RendleyService.getEngine().getUndoManager().undo();
    };
    const handleRedo = async () => {
        await RendleyService.getEngine().getUndoManager().redo();
    };

    const handleToggleRange = () => {
        ApplicationStore.setRangeToolEnabled(!ApplicationStore.rangeToolEnabled);
    };

    const isClipSelected = selectedLibrettoClipId != null;
    const isTransitionSelected = selectedTransitionId != null;
    const isSplitEnabled = isClipSelected;
    const isRangeToolEnabled = isClipSelected;
    const isTrashEnabled = isClipSelected || isTransitionSelected;

    return (
        <Paper>
            <div className="controls">
                <div className="controls__section">
                    {timelineHidden ?
                        <Button onClick={toggleTimelineHide}>
                            {"Show timeline"}
                        </Button> : <Button onClick={toggleTimelineHide}>{"Hide Timeline"}</Button>}


                    {/*<Button disabled={!isTrashEnabled} onClick={handleTrash}>*/}
                    {/*  <TrashIcon />*/}
                    {/*</Button>*/}
                </div>

                <div className="controls__section">
                    <Button onClick={handleStop}>
                        <div className="controls__section--stop-btn"></div>
                    </Button>

                    {isPlaying ? (
                        <Button onClick={handlePause}>
                            <PauseIcon/>
                        </Button>
                    ) : (
                        <Button onClick={handlePlay}>
                            <PlayIcon/>
                        </Button>
                    )}
                    <span className="controls__playback__time">{displayTime}</span>
                </div>

                <div className="controls__section">

                    <Button disabled={!isSplitEnabled} onClick={handleSplit} title={"Blade"}>
                        <ScissorsIcon/>
                    </Button>

                    <Button disabled={!isRangeToolEnabled} onMouseDown={handleToggleRange} variant={rangeEnabled ? "primary" : "ghost"} title={"Range"}>
                        <RangeIcon/>
                    </Button>

                </div>
            </div>
        </Paper>
    );
};

export default Controls;